import { KngButtonState, KngFooterState } from 'kinetic-angular';
import { Image } from 'projects/kinetic-angular/src/lib/shared/shared.interface';

export interface MainEntry {
  state: MainEntryState;
}

export interface MainEntryState {
  isLoading: boolean;
  sectionTop: MainEntrySectionTop;
  sectionMiddle: MainEntrySectionMiddle;
  sectionBottom: MainEntrySectionBottom;
}

export interface MainEntrySectionTop {
  globalHeader: GlobalHeader[];
  tags: Tag[];
}

export interface MainEntrySectionMiddle {
  banner: BannerLabels;
  iconsDeskTopView: IconsDeskTopView[];
  iconsMobileView: IconsMobileView[];
}

export interface MainEntrySectionBottom {
  footer: KngFooterState;
}

export interface BannerLabels {
  bannerImageDesktopView: Image;
  bannerImageMobileView: Image;
  header: string;
  subText: string;
  bulletPoints: BulletPoint[];
  registerButton: KngButtonState;
}
export interface MainEntryAemLabels {
  globalHeader: GlobalHeader[];
  banner: Banner;
  iconsDeskTopView: IconsDeskTopView[];
  iconsMobileView: IconsMobileView[];
  footer: Footer;
  tags: Tag[];
}

export interface Footer {
  ribbonImage: string;
  altText: string;
  footercontent: Footercontent;
  cssClass: string;
}

export interface Footercontent {
  css: {
    ecomm: string;
  };
  script: {};
  unifiedFooter: string;
}

export interface CountryLanguageOptions {
  countryLanguageOptions: CountryLanguageOption[];
}

export interface CountryLanguageOption {
  label: string;
  value: string;
}

export interface Copyright {
  label: string;
  labelUrl: LabelUrl[];
}

export interface LabelUrl {
  label: string;
  url: string;
}

export interface Footermenu {
  id: string;
  label: string;
  iconPath: string;
  altText: string;
  labelValue: string[];
  url: string;
}

export interface GlobalHeader {
  isSelected: boolean;
  iconPath: string;
  altText: string;
  url: string;
  label: string;
  cssClass: string;
  id: string;
  submenu: string[];
}

export interface Banner {
  bannerImageDesktopView: Image;
  bannerImageMobileView: Image;
  header: string;
  subText: string;
  bulletPoints: BulletPoint[];
  registerButton: string;
}

export interface BulletPoint {
  id: string;
  label: string;
}

export interface IconsDeskTopView {
  icon: Image;
  label: string;
  id: string;
  link: Link;
}
export interface IconsMobileView {
  icon: Image;
  label: string;
  id: string;
  link: Link;
}

export interface Link {
  text?: string;
  url?: string;
  icon?: Image;
}
export interface Tag {
  id: string;
  label: string;
  description: string;
  type: string;
}
